module.exports = __webpack_public_path__ + "ca1ae89fc69b9feb7bd0657b65efc6ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C00000N6Q.png
// module id = 1606
// module chunks = 0